import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Form, Modal } from 'antd';
import { useState } from 'react';
import CustomInputNumber from '../../../../../v2-components/Antd/InputNumber';
import CustomTable from '../../../../../v2-components/Antd/Table';
import SearchProductMagistralPrepared from './components/Search';



const MagistralFinishedRow = ({ product, onDiscountUpdate }) => {
  const [discountModalVisible, setDiscountModalVisible] = useState(false);
  const [currentDiscount, setCurrentDiscount] = useState(product.discount_percent || 0);



  return (
    <div >
      <Modal
        title="Aplicar Descuento (%)"
        open={discountModalVisible}
        onOk={() => {
          onDiscountUpdate(product.id, currentDiscount);
          setDiscountModalVisible(false);
        }}
        onCancel={() => setDiscountModalVisible(false)}
      >
        <p>Aplica un porcentaje de descuento al producto:</p>
        <CustomInputNumber
          min={0}
          max={100}
          value={currentDiscount}
          onChange={setCurrentDiscount}
          formatter={value => `${value}%`}
          parser={value => value.replace('%', '')}
          style={{ width: '100%' }}
        />
      </Modal>
    </div>
  );
};


const MagistralFinishedSection = ({
  products,
  onProductSelect,
  onDelete,
  onUpdateQuantity,
  onUpdateDiscount,
  isSearchVisible,
  status
}) => {

  console.log('products',products)


  const expandedKeys = products.map(p => p.id);
  const hasProducts = products && products.length > 0;
  if (!isSearchVisible && !hasProducts) {
      return null;
  }

  const handleSelect = (item) => {
    onProductSelect(item);
  };

  const handleUpdateDiscount = (id, discountPercent) => {
    onUpdateDiscount(id, discountPercent);
  };

  

  const columns = [
    {
      title: "Nombre del producto",
      dataIndex: "name",
      key: "name_provider",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={record.image_url}
            alt={record.editable_name}
            style={{ width: 30, height: 30, marginRight: 10 }}
          />
          <div style={{ padding: '4px 0' }}>
            <p style={{ fontSize: 12 }}>{record.name}</p>
            <div style={{ fontSize: 12, color: "#666" }}>
              <p> Laboratorio: {record.laboratory}</p>
              <p>Sku farmacia: {record.code_internal} </p>
            </div>
          </div>
        </div>
      )
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
      width: 100,
      render: (_, record) => (
        <CustomInputNumber
          disabled={status!==100}
          min={1}
          value={record.quantity}
          onChange={(value) => onUpdateQuantity(record.id, value)}
          style={{ width: '80px' }}
        />
      ),
    },
    {
      title: "Precio u.",
      dataIndex: "price_unit",
      key: "price_unit",
      width: 100,
      render: (val) => `$${val}`,
    },
    {
      title: "Desc. u.",
      dataIndex: "discount_percent",
      key: "discount_percent",
      width: 100,
      render: (discount, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {discount}%
          <Button
            disabled={status!==100}
            icon={<EditOutlined />}
            type="text"
            size="small"
            onClick={() => {
              Modal.info({
                title: 'Aplicar Descuento',
                footer: null,
                content: (
                  <MagistralDiscountModal
                    currentDiscount={record.discount_percent}
                    onSave={(newDiscount) => handleUpdateDiscount(record.id, newDiscount)}
                  />
                ),
                okText: "Aplicar"
              })
            }}
          />
        </div>
      ),
    },
    {
      title: "Precio final u.",
      dataIndex: "final_price_unit",
      key: "final_price_unit",
      width: 120,
      render: (val) => `$${val.toFixed(0)}`,
    },
    {
      title: "Precio final",
      dataIndex: "final_price",
      key: "final_price",
      width: 120,
      render: (val) => `$${val.toFixed(0)}`,
    },

    {
      title: "Eliminar",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <Button
        disabled={status!==100}
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onDelete(record.id)}
        />
      ),
    },
  ];

  const MagistralDiscountModal = ({ currentDiscount, onSave }) => {
    const [discount, setDiscount] = useState(currentDiscount || 0);

    return (
      <Form layout="vertical">
        <Form.Item label="Porcentaje de Descuento (%)">
          <CustomInputNumber
            min={0}
            max={100}
            value={discount}
            onChange={setDiscount}
            formatter={value => `${value}%`}
            parser={value => value.replace('%', '')}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Button
          type="primary"
          onClick={() => {
            onSave(discount);
            Modal.destroyAll();
          }}
        >
          Aplicar
        </Button>
      </Form>
    );
  };




  return (
    <div className="magistral-finished-section">
        {isSearchVisible && (
        <div style={{ marginBottom: 16 }}>
          <SearchProductMagistralPrepared
            onProductSelect={handleSelect}
          />
        </div>
      )}
      {hasProducts && (
        <div style={{ position: "relative", zIndex: 1 }}>
          <CustomTable
            columns={columns}
            dataSource={products}
            locale={{
              emptyText: (
                <div style={{ padding: '20px 0', color: '#999' }}>
                  <span>Aún no has agregado productos magistrales a tu receta.</span>
                </div>
              )
            }}
            rowKey="id"
            pagination={false}
            expandedRowKeys={expandedKeys}
            expandedRowRender={(record) => (
              <MagistralFinishedRow 
                  product={record} 
                  onDiscountUpdate={onUpdateDiscount}  //to check
              />
            )}
            expandIcon={() => null}
            expandRowByClick={false}
          />
        </div>
      )}
    </div>
  );
};

export default MagistralFinishedSection;